import React from "react";
import JourneyStep from "./JourneyStep";
import classes from "./JourneyProgress.module.scss";
import { useLocation } from "react-router-dom";
interface Props {
  mobile?: boolean;
  className?: string;
}

function getProgress(currentStep: number, step: number) {
  if (step === currentStep) {
    return "current";
  }
  return step < currentStep ? "complete" : "incomplete";
}

function JourneyProgress(props: Props) {
  const { pathname } = useLocation();

  let step = 1;
  if (pathname.match(/^\/locations\/[^/]+\/?$/)) {
    step = 2;
  } else if (pathname.match(/^\/locations\/[^/]+\/units\/?$/)) {
    step = 3;
  } else if (pathname.match(/^\/booking$/)) {
    step = 3;
  } else if (pathname.match(/^\/locations\/[^/]+\/quote-sent$/)) {
    step = 3;
  } else if (
    pathname.match(/^\/locations\/[^/]+\/(book|reserve|book-confirmed|booking)\/?$/)
  ) {
    step = 4;
  }

  const className = [
    classes.journeyBar,
    props.mobile && classes.mobile,
    props.mobile ? "d-lg-none" : "d-none d-lg-flex",
    props.className,
  ].join(" ");

  return (
    <div className={className}>
      {!props.mobile && (
        <JourneyStep progress={getProgress(step, 1)} first>
          Location
        </JourneyStep>
      )}
      <JourneyStep progress={getProgress(step, 2)} first={props.mobile}>
        {props.mobile ? "Type" : "Storage Type"}
      </JourneyStep>
      <JourneyStep progress={getProgress(step, 3)}>Quote</JourneyStep>
      <JourneyStep progress={getProgress(step, 4)}>Book</JourneyStep>
    </div>
  );
}

export default JourneyProgress;
